const getColors = theme => theme.colors;

export default getColors;
